import React from 'react'
import { Controller, FormContext } from 'react-hook-form'
import { SettingsBuilder } from 'components/TasksV2/TaskCreation/components/SettingsBuilder'
import { CreateActionPopSwitch } from 'components/TasksV2/TaskCreation/Steps/TaskSettingStep/CreateActionPopSwitch'
import { useAiSettingsForm } from '../../hooks/useAiSettingsForm'
import { useAiCreationText } from '../../hooks/useAiCreationText'
import { BriefingSchedule } from '../BriefingSchedule'

export default function AISettingsStep({ headerSlot }: { headerSlot?: HTMLDivElement | null }) {
  const { methods, values, offsetMinutes, maxOffsetMinutes, setOffsetMinutes } = useAiSettingsForm()
  const t = useAiCreationText()

  return (
    <FormContext {...methods}>
      <SettingsBuilder
        headerSlot={headerSlot}
        actionLabel={t.generate}
        hiddenSections={['auditors', 'watchers', 'view', 'priority']}
        showReviewDeadline={false}
        advancedExtra={<CreateActionPopSwitch number={5} />}
        advancedExtraEnabled={values.send_action_pop}
        extension={{
          label: t.briefing,
          summary:
            offsetMinutes === -2 ? t.halfway : offsetMinutes === -1 ? t.whenDone : `${offsetMinutes} ${t.minutes}`,
          content: (
            <BriefingSchedule
              offsetMinutes={offsetMinutes}
              maxOffsetMinutes={maxOffsetMinutes}
              onOffsetChange={setOffsetMinutes}
            />
          ),
        }}
      />
      <Controller name="type" control={methods.control} as={<span hidden />} />
      <Controller name="auditors" control={methods.control} as={<span hidden />} />
    </FormContext>
  )
}
